import { Map, Record } from 'immutable';

export interface CommonState extends Map<string, any> {
    getPostListLoading: boolean;
    getPostListData: any;
    getPostListFailData: any;
    getPostListDataAmount: number;

    getPostItemLoading: boolean;
    getPostItemData: any;
    getPostItemFailData: any;

    removePostItemLoading: boolean;
    removePostItemData: any;
    removePostItemFailData: any;

    createPostItemLoading: boolean;
    createPostItemData: any;
    createPostItemFailData: any;

    updatePostItemLoading: boolean;
    updatePostItemData: any;
    updatePostItemFailData: any;

    getCategoryListLoading: boolean;
    getCategoryListData: any;
    getCategoryListFailData: any;

    getCategoryItemLoading: boolean;
    getCategoryItemData: any;
    getCategoryItemFailData: any;

    createTagItemLoading: boolean;
    createTagItemData: any;
    createTagItemFailData: any;

    updateTagItemLoading: boolean;
    updateTagItemData: any;
    updateTagItemFailData: any;

    removeTagItemLoading: boolean;
    removeTagItemData: any;
    removeTagItemFailData: any;

    getTagItemLoading: boolean;
    getTagItemData: any;
    getTagItemFailData: any;

    getTagListLoading: boolean;
    getTagListData: any;
    getTagListFailData: any;

    removeImageFromPostLoading: boolean;
    removeImageFromPostData: any;
    removeImageFromPostFailData: any;
}

export const CommonRecord = Record({
    getPostListLoading: false,
    getPostListData: null,
    getPostListFailData: null,
    getPostListDataAmount: 0,

    getPostItemLoading: false,
    getPostItemData: null,
    getPostItemFailData: null,

    removePostItemLoading: false,
    removePostItemData: null,
    removePostItemFailData: null,

    createPostItemLoading: false,
    createPostItemData: null,
    createPostItemFailData: null,

    updatePostItemLoading: false,
    updatePostItemData: null,
    updatePostItemFailData: null,

    getCategoryListLoading: false,
    getCategoryListData: null,
    getCategoryListFailData: null,

    getCategoryItemLoading: false,
    getCategoryItemData: null,
    getCategoryItemFailData: null,

    createTagItemLoading: false,
    createTagItemData: null,
    createTagItemFailData: null,

    updateTagItemLoading: false,
    updateTagItemData: null,
    updateTagItemFailData: null,

    removeTagItemLoading: false,
    removeTagItemData: null,
    removeTagItemFailData: null,

    getTagItemLoading: false,
    getTagItemData: null,
    getTagItemFailData: null,

    getTagListLoading: false,
    getTagListData: null,
    getTagListFailData: null,

    removeImageFromPostLoading: false,
    removeImageFromPostData: null,
    removeImageFromPostFailData: null
});
